import { mapGetters } from 'vuex'
export default {
  name: 'Radio-Button',
  components: {},
  props: ['className'],
  data () {
    return {

    }
  },
  computed: {
    style () {
      return `content: "${this.content.string}"`
    }
  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/SignupRadioButton/component.js